import React, { FormEvent, KeyboardEvent, ReactNode } from 'react';
import * as moment from 'moment';
import { Button, ControlLabel, FormControl, FormGroup, InputGroup, Table, Well } from 'react-bootstrap';

interface IProps {
    reportStart: string,
    reportEnd: string,
    customRange: boolean,
    included: boolean,
    favorable: boolean,
    compatible: boolean,
    transplanted: boolean,
    onReportStartChange: (reportStart: string) => void,
    onReportEndChange: (reportEnd: string) => void,
    onReportRangeUpdate: () => void,
    onFilterToggle: (name: string, value: boolean) => void,
    children: ReactNode
}

const Header = ({ reportStart, reportEnd, customRange, included, favorable, compatible, transplanted, onReportStartChange, onReportEndChange, onReportRangeUpdate, onFilterToggle, children }: IProps) => {
    const handleDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        if (name == 'reportStart') {
            onReportStartChange(value);
        }

        if (name == 'reportEnd') {
            onReportEndChange(value);
        }
    };

    const handleDateKeyUp = (e: KeyboardEvent<FormControl & HTMLInputElement>) => {
        if (e.key == 'Enter') {
            onReportRangeUpdate();
        }
    };

    const handleFilterToggle = (e: FormEvent<HTMLButtonElement>) => {
        if (e.currentTarget.name == 'included') {
            onFilterToggle(e.currentTarget.name, !included);
        }

        if (e.currentTarget.name == 'favorable') {
            onFilterToggle(e.currentTarget.name, !favorable);
        }

        if (e.currentTarget.name == 'compatible') {
            onFilterToggle(e.currentTarget.name, !compatible);
        }
    };

    const handleTransplantedToggle = (e: FormEvent<HTMLButtonElement>) => {
        let transplanted: boolean = null;

        if (e.currentTarget.value == '1') {
            transplanted = true;
        }

        if (e.currentTarget.value == '0') {
            transplanted = false;
        }

        onFilterToggle('transplanted', transplanted);
    };

    return (
        <Well bsSize='sm' style={{ marginBottom: 5 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <div className='form-inline'>
                        <FormGroup style={{ marginRight: 50 }}>
                            <ControlLabel>Report Range:&nbsp;</ControlLabel>
                            <InputGroup>
                                {customRange
                                    ? <FormControl name='reportStart' type='date' onChange={handleDateChange} onKeyUp={handleDateKeyUp} value={reportStart} />
                                    : <InputGroup.Addon>{moment(reportStart).format('MM/DD/YYYY')}</InputGroup.Addon>
                                }
                                <InputGroup.Addon>&nbsp;-&nbsp;</InputGroup.Addon>
                                <FormControl name='reportEnd' type='date' onChange={handleDateChange} onKeyUp={handleDateKeyUp} value={reportEnd} />
                                <InputGroup.Button>
                                    <Button bsStyle='primary' onClick={onReportRangeUpdate}>Update</Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </FormGroup>
                        <FormGroup style={{ marginRight: 50 }}>
                            <ControlLabel>Filter:&nbsp;</ControlLabel>
                            <div className='btn-group' role='group' aria-label='filters'>
                                <button type='button' name='favorable' className={favorable ? 'btn btn-primary' : 'btn btn-default'} onClick={handleFilterToggle}>Favorable</button>
                                <button type='button' name='compatible' className={compatible ? 'btn btn-primary' : 'btn btn-default'} onClick={handleFilterToggle}>Compatible</button>
                                <button type='button' name='included' className={included ? 'btn btn-primary' : 'btn btn-default'} onClick={handleFilterToggle}>Included</button>
                            </div>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Transplanted:&nbsp;</ControlLabel>
                            <button type='button' name='transplanted' className={transplanted == true ? 'btn btn-primary' : 'btn btn-default'} value='1' onClick={handleTransplantedToggle}>Yes</button>
                            <button type='button' name='tranplanted' className={transplanted == false ? 'btn btn-primary' : 'btn btn-default'} value='0' onClick={handleTransplantedToggle}>No</button>
                            <button type='button' name='tranplanted' className={transplanted == null ? 'btn btn-primary' : 'btn btn-default'} value='-1' onClick={handleTransplantedToggle}>Either</button>
                        </FormGroup>
                    </div>
                </div>
                <div>
                    <Table bordered style={{ width: 'initial', backgroundColor: 'white', marginBottom: 0 }}>
                        <tbody>
                            {children}
                        </tbody>
                    </Table>
                </div>
            </div>
        </Well>
    );
}

export default Header;